<template>
  <div>
    <div class="day-cal">
      <div class="day-cal__container">
        <ul class="day-cal__time-sidebar">
          <li class="time-hours"
              v-for="n in hoursInLocale">
            {{n}}
          </li>
        </ul>
        <div class="container">
          <ul class="day-cal__time-background">
            <li class="time-slot" v-for="n in hours.length * 2" :class="{today: isToday}"></li>
            <now-indicator v-if="isToday"
                           :start="start"
                           :slotHeight="slotHeight">
            </now-indicator>
          </ul>
          <div class="day-cal__event-container">
            <template v-for="event in correctEvents">
              <cal-event
                :event="event"
                :start="start"
                :i18n="i18n"
                @eventClicked="onTap">
              </cal-event>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import calEvent from './DayCalEvent.vue'
  import nowIndicator from './NowIndicator.vue'
  import moment from 'moment' // eslint-disable-line no-unused-vars
  import config from '../../../../config' // eslint-disable-line no-unused-vars

  export default {
    props: {
      date: {
        default: () => config.now
      },
      events: {
        type: Array,
        default: () => []
      },
      viewState: {
        type: Number,
        default: 0
      },
      locale: {
        default: window.USER && window.USER.locale ? window.USER.locale : 'en'
      },
      i18n: {}
    },
    components: {calEvent, nowIndicator},
    data () {
      return {
        slotHeight: 40,
        correctEvents: [],
        firstEvent: true
      }
    },
    computed: {
      start () {
        if (this.viewState !== 2) {
          return 6
        } else {
          return 0
        }
      },
      end () {
        if (this.viewState !== 2) {
          return 18
        } else {
          return 24
        }
      },
      isToday () {
        let date = moment(this.date).format('YYYY-MM-DD')
        let today = moment().format('YYYY-MM-DD')
        return moment(date).isSame(today)
      },
      dayLessons () {
        return this.events.filter(lesson => {
          let lessonDate = moment(lesson.start).format('YYYY-MM-DD')
          let day = moment(this.date).format('YYYY-MM-DD')
          return moment(lessonDate).isSame(day)
        })
      },
      hours () {
        let hours = []
        for (let i = this.start; i <= this.end; i++) {
          hours.push(i)
        }
        return hours
      },
      hoursInLocale () {
        let localeHours = []
        this.hours.forEach(h => {
          let mom = moment().set({hour: h, minutes: 0, seconds: 0})
          localeHours.push(moment(mom).locale(this.locale).format('LT'))
        })
        return localeHours
      }
    },
    watch: {
      dayLessons () {
        this.correctEvents = []
        this.setWidthAndLeft()
        this.firstEvent = true
      }
    },
    methods: {
      onTap (lesson) {
        this.$emit('eventClicked', lesson)
      },
      getHeightOfTimeSlots () {
        let height = document.getElementsByClassName('time-slot')[1].getBoundingClientRect().height
        this.slotHeight = height
      },
      eventTop (event) {
        let calStartTime = moment(event.start).hour(this.start).minutes('0')
        let eventStartTime = moment(event.start)
        let duration = moment(eventStartTime).diff(calStartTime)
        return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
      },
      eventHeight (event) {
        let duration = moment(event.end).diff(event.start)
        return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
      },
      eventBottom (event) {
        let calStartTime = moment(event.end).hour(this.start).minutes('0')
        let eventEndTime = moment(event.end)
        let duration = moment(eventEndTime).diff(calStartTime)
        return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
      },
      // Check if two events collide
      collidesWith (a, b) {
        return a.bottom > b.top && a.top < b.bottom
      },
      packEvents (columns) {
        let n = columns.length
        for (let i = 0; i < n; i++) {
          let col = columns[i]
          for (let j = 0; j < col.length; j++) {
            let ev = col[j]
            let colSpan = this.expandEvent(ev, i, columns)
            col[j].left = (i / n) * 100
            col[j].width = 100 * colSpan / n
            this.correctEvents.push(col[j])
            // Scroll cal to first event
            if (this.firstEvent) {
              this.$emit('lessonsUpdate', this.correctEvents[0])
            }
            this.firstEvent = false
          }
        }
      },
      expandEvent (ev, iColumn, columns) {
        let colSpan = 1
        for (let i = iColumn + 1; i < columns.length; i++) {
          let col = columns[i]
          for (let j = 0; j < col.length; j++) {
            let ev1 = col[j]
            if (this.collidesWith(ev, ev1)) {
              return colSpan
            }
          }
          colSpan++
        }
        return colSpan
      },
      setWidthAndLeft () {
        let columns = []
        let lastEventEnding = null
        let events = this.dayLessons.map(elem => {
          const top = this.eventTop(elem)
          const height = this.eventHeight(elem)
          const bottom = this.eventBottom(elem)
          return {
            'obj': elem,
            'top': top,
            'height': height,
            'bottom': bottom
          }
        })
        events = events.sort(function (e1, e2) {
          if (e1.top < e2.top) return -1
          if (e1.top > e2.top) return 1
          if (e1.bottom < e2.bottom) return -1
          if (e1.bottom > e2.bottom) return 1
          return 0
        })
        for (let i = 0; i < events.length; i++) {
          let e = events[i]
          if (lastEventEnding !== null && e.top >= lastEventEnding) {
            this.packEvents(columns)
            columns = []
            lastEventEnding = null
          }
          let placed = false
          for (let j = 0; j < columns.length; j++) {
            let col = columns[j]
            if (!this.collidesWith(col[col.length - 1], e)) {
              col.push(e)
              placed = true
              break
            }
          }
          if (!placed) {
            columns.push([e])
          }
          if (lastEventEnding === null || e.bottom > lastEventEnding) {
            lastEventEnding = e.bottom
          }
        }
        if (columns.length > 0) {
          this.packEvents(columns)
        }
      }
    },
    mounted () {
      this.getHeightOfTimeSlots()
    }
  }
</script>

<style scoped>
  .day-cal {
    background: white;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
  }

  .day-cal__container {
    display: flex;
    position: relative;
  }

  .day-cal__time-sidebar {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-right: 12px;
  }

  .day-cal__time-background {
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
  }

  .container {
    display: flex;
    position: relative;
    flex: 1;
  }

  .day-cal__time-sidebar > .time-hours:first-child {
    opacity: 0;
  }

  .day-cal__time-sidebar > .time-hours {
    color: #8e8e93;
    flex: 1;
    margin-top: -10px;
  }

  .day-cal__time-background > .time-slot {
    flex: 1;
    width: 100%;
    min-height: 40px;
    border-top: 1px solid rgba(217, 217, 217, .7);
    z-index: 1;
  }

  .day-cal__time-background > .time-slot.today {
    background-color: #f2f8fe;
  }

  .day-cal__time-background > .time-slot:first-child {
    border-top: none;
  }

  .day-cal__time-background > .time-slot:nth-child(2n) {
    border-top-style: dotted;
  }

  .day-cal__event-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// DayCal.vue?66de2808